// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__8If_v","footer":"ChangeClinic_footer__2GW4b"};